import React, { useEffect, useState } from 'react';
import { IoMdCart } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { addToCartAction } from '../../actions';
import { getInitialDataAction } from '../../actions/initialData.action';
import Layout from '../../components/Layout';
import { MaterialButton } from '../../components/MaterialUI';
import Card from '../../components/UI/Card';
import Price from '../../components/UI/Price';
import Rating from '../../components/UI/Rating';
import { generatePublicUrl, shorten } from '../../HelperFunction';
import './style.css';

// function groupBy(objectArray, property) {
// 	return objectArray.reduce(function(acc, obj) {
// 		var key = obj[property];
// 		if (!acc[key]) {
// 			acc[key] = [];
// 		}
// 		acc[key].push(obj);
// 		return acc;
// 	}, {});
// }


export default function Home(props) {
	const dispatch = useDispatch();
	const product = useSelector((state) => state.product);
	const category = useSelector((state) => state.category);
	const [products, setProducts] = useState([]);

	// useEffect(() => {
	// 	const productList = localStorage.getItem('FilteredProducts', JSON.parse(filteredProducts));
	// 	setProducts(productList);
	// }, [category])

	// console.log({ products });

	useEffect(() => {
		document.title = 'Bienvenu - MimiShop Ouaga';
	}, []);

	useEffect(() => {
		dispatch(getInitialDataAction());
	}, []);


	return (
		<Layout>
			<div
				style={{
					maxWidth: '1200px',
					margin: '30px auto'
				}}
			>
				{ product.allProducts.map((item, index) => (
					<Card style={{ display: 'flex', padding: '40px', margin: '40px auto' }}>
						<Link to={`/${item.category.name}/${item._id}/p`}>
							<div className="flexRow">
								<div style={{ flex: 2 }}>
									<div className="ItemImgContainer">
										<img
											src={generatePublicUrl(item.productPictures[0].img)}
											alt={item.productPictures[0].img}
										/>
									</div>
								</div>
								<div className="sb" style={{ flex: 10, padding: '0 60px' }}>
									<div className="ItemInfoContainer">
										<div className="ItemName">{item.name}</div>
										<div className="ItemDesc">
											<span>{shorten(item.description, 200)}...</span>
										</div>
										<div className="ItemDesc">
											<span>Quantité Disponible: {item.quantity}</span>
										</div>
										<div>
											<Rating value={Math.round(Math.random() * 5 * 10) / 10} />
										</div>
										<div className="ItemPrice">
											<Price fontSize="20px" value={item.price} />
										</div>
									</div>
								</div>
							</div>
						</Link>
						<div>
							<MaterialButton
								title="AJOUTER AU PANNIER"
								bgColor="#ff9f00"
								textColor="#ffffff"
								style={{
									width: '240px',
									float: 'right'
								}}
								icon={<IoMdCart />}
								onClick={() => {
									const { _id, name, price, deliveryFee } = item;
									const img = item.productPictures[0].img;
									dispatch(addToCartAction({ _id, name, price, img, deliveryFee }));
									props.history.push(`/cart`);
								}}
							/>
						</div>
					</Card>
				))}
			</div>
		</Layout>
	);
}
